class BatchGeoAdminUserDeleteAndReassign {
  constructor() {
    //two main options (delete and reassign | delete)
    const reassignRadios = $(".reassign-radio-input");

    //subuser list
    const subuserList = $(".subuser-list");

    //set $prev to the first radio option
    this.$prev = $(".reassign-input");

    //updated with user id when delete button is clicked, default as null
    this.userToDelete = null;
    this.userEmail = null;

    reassignRadios.on("change", (e) => {
      const $new = $(e.currentTarget);

      // if there was a previously checked radio and it’s not the same as the newly checked
      if (this.$prev.length && !$new.is(this.$prev)) {
        //toggle subuser list
        subuserList.toggle();

        //second radio option has delete-user class
        if ($new.hasClass("delete-user")) {
          //uncheck the user set to be reassigned too
          const checkedUser = $('input[name="user-to-assign"]:checked');
          checkedUser.prop("checked", false);

          //update text in delete button
          $("#reassign-delete-button").text("Confirm Deletion");
        } else {
          //set the primary user to checked
          $(".primary").prop("checked", true);

          //update delete button text
          $("#reassign-delete-button").text("Reassign and delete");
        }
      }

      //update prev with new
      this.$prev = $new;
    });

    document
      .getElementById("reassign-delete-button")
      .addEventListener("click", async () => {
        //set loading here
        let btn = $("#reassign-delete-button");
        this.setButtonLoading(btn, true);

        //find the user that was checked for assignment
        const checked = document.querySelector(
          'input[name="user-to-assign"]:checked',
        );
        //call reassignAndDelete function with userToDelete and the checked value
        //if there was no checked value, user is being deleted without reassignment
        const response = await this.reassignAndDelete(
          this.userToDelete,
          checked ? checked.id : null,
          this.userEmail,
        );

        //parse response
        const status = JSON.parse(response);

        //remove loading here
        this.setButtonLoading(btn, false);

        //if successful, reload
        if (status.success) {
          //not neccesary, but lets the network tab stabilize
          this.hideDeleteUserModal();

          BatchGeo.customDialog(status.message, {
            showConfirmBtn: true,
            confirmFn: () => {
              this.onSuccessfulSubUserDelete();
            },
            confirmText: "OK",
          });
        } else {
          //update error tag with error message
          $(".error-tag").text(status.message);
        }
      });

    //hide the modal if cancel is clicked
    document
      .getElementById("cancel-delete-button")
      .addEventListener("click", () => {
        this.hideDeleteUserModal();
      });
  }

  onSuccessfulSubUserDelete() {
    window.location.reload(true);
  }

  showDeleteUserModal(context) {
    //store user id that was clicked to open modal (this user will be deleted)
    const { userId, mapCount, name, email } = context.dataset;

    //update global userToDelete value
    this.userToDelete = userId;
    this.userEmail = email;

    //reset $prev when the delete modal is opened to the first option
    this.$prev = $(".reassign-input");

    //check the first option by default
    $(".reassign-input").prop("checked", true);

    //check the primary user by default
    $(".primary").prop("checked", true);

    //show users that might have been hidden previously
    $(`div[data-email]:not([data-email='${email}'])`).each((index, element) => {
      $(element).show();
    });

    //hide selected user from sub user list for reassignment
    $(`div[data-email='${email}']`).each((index, element) => {
      $(element).hide();
    });

    //update modal text with users name that will be deleted
    console.log("what is the name...: ", name);
    $(".delete-user-title").text(name);

    //update modal text with users map count
    $(".map-count").text(mapCount);

    //if theres no maps for this user, show that version/message
    if (mapCount == 0) {
      //show no maps description
      $("#no-maps-description").show();

      //hide reassignment details
      $("#maps-description").hide();
      $("#delete-reassign-container").hide();
      $(".subuser-list").hide();
      $("#delete-user-container").hide();

      //update deleted button text
      $("#reassign-delete-button").text("Delete user");

      //unchecked the user checked by default
      $('input[name="user-to-assign"]:checked').prop("checked", false);
    } else {
      //hide no maps description
      $("#no-maps-description").hide();

      //show reassignment details
      $("#maps-description").show();
      $("#delete-reassign-container").show();
      $(".subuser-list").show();
      $("#delete-user-container").show();

      $("#reassign-delete-button").text("Reassign and delete");
    }

    //show the modal /w correct details
    $("#delete-user-modal").show();
  }

  hideDeleteUserModal() {
    //clear any error
    $(".error-tag").text("");

    //hide the modal
    $("#delete-user-modal").hide();
  }

  setButtonLoading(button, isLoading) {
    if (isLoading) {
      //save text as original-text on button
      if (!button.data("original-text")) {
        button.data("original-text", button.html());
      }

      //disable the button
      button.prop("disabled", true);

      //add loading spinner
      button.html('<span class="spinner"></span>Deleting...');
    } else {
      //reenable button
      button.prop("disabled", false);

      //reset button text
      button.html(button.data("original-text"));
    }
  }

  reassignAndDelete = async function (
    user_id_to_delete,
    user_id_to_reassign_maps_to,
    user_email,
  ) {
    return await $.post("/api/reassignMapsAndDelete/", {
      user_id_to_delete,
      user_id_to_reassign_maps_to,
      user_email,
    });
  };
}

window.BatchGeoAdminUserDeleteAndReassign = BatchGeoAdminUserDeleteAndReassign;
